import styled from "styled-components";
import { breakpoint } from "../../utils/styleMixins";

const H1 = styled.h1`
  color: #0a587e;
  text-transform: uppercase;
  font-weight: bold;
  line-height: 25px;
  margin: 0px 0px 10px 0;
  font-size: 22px;
  ${breakpoint.sm.max`
    font-size: 18px;
  `}
`;

export default H1;
